import { useCurrentUser } from '../../services/userHooks';
import { buildSaveEmail } from '../../utils/inboundEmail';
import CopyableEmail from './CopyableEmail';

/**
 * The "Save Directly to Folders" section body. Signed in, it shows a table of
 * each folder's dedicated save address (readlater.<hash>+<folderId>@instapaper.com).
 * Logged out, it explains that the addresses appear here once the reader logs in.
 */
function FolderAddressesSection() {
  const { currentUser } = useCurrentUser();
  const folders = currentUser?.folders ?? [];
  const saveEmail = buildSaveEmail(currentUser);

  if (!saveEmail) {
    return (
      <p className="docs-paragraph">
        You can save directly to folders via dedicated email addresses. When you're{' '}
        <a
          href="https://www.instapaper.com/user/login"
          className="docs-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          logged in
        </a>
        , the save to folder email addresses will appear below.
      </p>
    );
  }

  if (folders.length === 0) {
    return (
      <p className="docs-paragraph">
        Create a folder to get a dedicated email address for saving directly to it.
      </p>
    );
  }

  return (
    <>
      <p className="docs-paragraph">
        You can save directly to folders via email using the email addresses below:
      </p>
      <div className="docs-table-wrapper">
        <table className="docs-table">
          <thead>
            <tr>
              <th className="docs-table-header">Folder</th>
              <th className="docs-table-header">Email address</th>
            </tr>
          </thead>
          <tbody>
            {folders.map((folder) => {
              const email = buildSaveEmail(currentUser, folder.id);
              if (!email) return null;
              return (
                <tr key={folder.id}>
                  <td className="docs-table-cell">{folder.displayTitle}</td>
                  <td className="docs-table-cell">
                    <CopyableEmail email={email} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default FolderAddressesSection;
